import { IN_PROGRESS } from "constants/common";
import { NAV_ACTIONS } from "constants/DynamicWidget";
import THEME from "constants/themes";
import DynamicWidgetContext from "contexts/DynamicWidget";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getUrlS3 } from "services/funcHelper";
import {
	StyledOutlineButton,
	StyledText,
	StyledWrapper,
} from "styled-components/Common/CommonStyled";
import { StyledSubmitButton } from "styled-components/WidgetBuilder/WidgetBuilderStyled";

const ActionButton = () => {
	const { t } = useTranslation();
	const {
		navigatePage,
		pagePosition,
		widgetDetails,
		clearForm,
		handleSubmitButton,
		isFileListEmpty,
	} = useContext(DynamicWidgetContext);
	const { metadata } = widgetDetails || {};
	const { colors: { bgSubmit, buttonUrl, highlight } = {} } = metadata || {};
	const { getLocationStatus, uploadSocialContentStatus } = useSelector(
		(state: any) => state.widgets,
	);

	const btnProps = {
		color: highlight || THEME.colors.darkBlue1,
		border: `1px solid ${THEME.colors.gray4}`,
		radius: "4px",
		height: "36px",
		fontSize: "16px",
		backgroundColor: THEME.colors.white,
	};

	const styles = {
		opacity: isFileListEmpty ? 0 : 1,
		transition: "opacity 0.2s",
	};

	return (
		<StyledWrapper display="flex" justifyContent="space-between" alignItems="center">
			<StyledText fontSize="16px" cursor="pointer" onClick={clearForm} style={styles}>
				{t("button.clear_form")}
			</StyledText>

			<StyledWrapper display="flex" gap="8px">
				{!pagePosition.isFirst && (
					<StyledOutlineButton
						type="ghost"
						{...btnProps}
						onClick={() => navigatePage(NAV_ACTIONS.BACK)}>
						{t("button.back")}
					</StyledOutlineButton>
				)}
				{pagePosition.isLast ? (
					<StyledSubmitButton
						className={buttonUrl ? "has_url" : ""}
						loading={getLocationStatus === IN_PROGRESS || uploadSocialContentStatus === IN_PROGRESS}
						onClick={handleSubmitButton}
						backgroundColor={bgSubmit}
						backgroundUrl={getUrlS3(buttonUrl || "")}
						style={{
							borderRadius: "4px",
							height: "36px",
							fontSize: "16px",
						}}>
						{t("button.submit")}
					</StyledSubmitButton>
				) : (
					<StyledOutlineButton
						type="ghost"
						{...btnProps}
						style={styles}
						onClick={() => navigatePage(NAV_ACTIONS.NEXT)}>
						{t("button.next")}
					</StyledOutlineButton>
				)}
			</StyledWrapper>
		</StyledWrapper>
	);
};

export default ActionButton;
